<template>
  <div>
    <!-- Montant conseillé -->
    <p v-if="reglesMetier.amount && reglesMetier.amount !== '0'" v-html="$t('regles_metier.details.montant', {amount: reglesMetier.amount})"></p>
    <!-- Nombre d'échéances -->
    <p v-html="$t('regles_metier.details.nbecheances', {min: reglesMetier.nbInstallments.min, max: reglesMetier.nbInstallments.max})"></p>
    <!-- Montant minimum par échéances -->
    <p v-html="$t('regles_metier.details.montant_devise', {montantMin: reglesMetier.minInstallmentAmountCurrency})"
      v-if="reglesMetier.minInstallmentAmountType === 'devise'">
    </p>
    <p v-html="$t('regles_metier.details.montant_percent', {montantMin: reglesMetier.minInstallmentAmountPercent})"
      v-if="reglesMetier.minInstallmentAmountType === 'percent'">
    </p>
    <!-- Délais max entre deux échéances consécutives -->
    <p v-if="reglesMetier.interval.day === '0' && reglesMetier.interval.month === '0' && reglesMetier.interval.year === '0'">
      {{$t('regles_metier.details.no_intervalle')}}
    </p>
    <p v-else>
      {{$t('regles_metier.details.intervalle')}}
      <b>
      <span v-if="reglesMetier.interval.year > 0"> {{reglesMetier.interval.year}} {{$t('regles_metier.annee').toLowerCase()}}</span>
      <span v-if="reglesMetier.interval.month > 0"> {{reglesMetier.interval.month}} {{$t('regles_metier.mois').toLowerCase()}}</span>
      <span v-if="reglesMetier.interval.day > 0"> {{reglesMetier.interval.day}} {{$t('regles_metier.jour').toLowerCase()}}</span>
    </b>
    </p>
    <!-- Délais max total -->
    <p v-if="(!reglesMetier.totalPeriod || reglesMetier.totalPeriod.day === '0')
    && (!reglesMetier.totalPeriod || reglesMetier.totalPeriod.month === '0')
    && (!reglesMetier.totalPeriod || reglesMetier.totalPeriod.year === '0')">
      {{$t('regles_metier.details.no_delais_max')}}
    </p>
    <p v-else>
      {{$t('regles_metier.details.delais_max')}}
      <b>
      <span v-if="reglesMetier.totalPeriod.year > 0"> {{reglesMetier.totalPeriod.year}} {{$t('regles_metier.annee').toLowerCase()}}</span>
      <span v-if="reglesMetier.totalPeriod.month > 0"> {{reglesMetier.totalPeriod.month}} {{$t('regles_metier.mois').toLowerCase()}}</span>
      <span v-if="reglesMetier.totalPeriod.day > 0"> {{reglesMetier.totalPeriod.day}} {{$t('regles_metier.jour').toLowerCase()}}</span>
    </b>
    </p>
  </div>

</template>

<script>
export default {
  name: 'EcheancierReglesDetails',
  props: ['reglesMetier'],
  computed: {
    regles () {
      return this.reglesMetier
    }
  }
}
</script>

<style lang="css" scoped>
</style>
